import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { AlfatecCredentialsDTORuntype, AlfatecResponseBodyDTORuntype } from './alfatecBackendTypes';

export const alfatecEndpoints = {
    'GET /3rdparty/alfatec/credentials': endpoint({
        description: 'Returns credentials for alfatec integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AlfatecResponseBodyDTORuntype,
    }),
    'POST /3rdparty/alfatec/credentials': endpoint({
        description: 'Uploads credentials for alfatec integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AlfatecCredentialsDTORuntype,
        responseBody: AlfatecResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/alfatec/credentials'],
    }),
    'PATCH /3rdparty/alfatec/credentials': endpoint({
        description: 'Updates credentials for alfatec integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AlfatecCredentialsDTORuntype,
        responseBody: AlfatecResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/alfatec/credentials'],
    }),
    'DELETE /3rdparty/alfatec/credentials': endpoint({
        description: 'Deletes existing credentials for alfatec integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/alfatec/credentials'],
    }),
};
